import { jsx as n } from "react/jsx-runtime";
const t = /codepen\.io\/(.+?)\/pen\/(.+?)(\?.+?)?$/, l = ({ href: e, title: a }) => {
  const [, s, o, r] = e.match(t);
  return /* @__PURE__ */ n(
    "iframe",
    {
      style: { width: "100%", aspectRatio: "2/1" },
      title: a,
      src: `https://codepen.io/${s}/embed/${o}${r || "?default-tab=html,result&theme-id=dark"}`,
      loading: "lazy",
      allowFullScreen: !0
    }
  );
}, m = (e) => t.test(e);
export {
  m as canEmbed,
  l as default
};
